let language = {
    BULK_ORDER_CHECKOUT_STEP_SHIPPING_ESHOPPER_SHIPPING_METHOD_TIP: `Used shipping method: {{shipmentMethod}} (The selected shipping method is not available for this country or region.)`,
    BULK_ORDER_CHECKOUT_STEP_SHIPPING_INVOICE_NULL_TIP: "bulkOrder invoice is null!",

    BULK_ORDER_CHECKOUT_STEP_SHIPPING_ADDRESS_NOT_SUPPORT: "The shipping address for this order is outside {{appName}}'s service coverage area.",
    BULK_ORDER_CHECKOUT_STEP_SHIPPING_ADDRESS_NOT_SUPPORT_712312: ":The current country not have VatId!",
};

export { language }